import { Box, Button, Chip, CircularProgress, Stack, TextField, Typography } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

const MAX_BRIEF_CHARS = 20000;

/** Same starting points offered by AI Mode, so the two feel like one product. */
const SAMPLES = [
  'Beauty influencers in Mumbai for a monsoon skincare launch',
  'Tech creators with high engagement for a laptop review campaign',
  'Fitness creators in Delhi, 10 micro creators, budget 3 lakh',
];

function BriefInput({ value, onChange, onAnalyse, loading }) {
  const tooLong = value.length > MAX_BRIEF_CHARS;
  const canAnalyse = value.trim().length > 0 && !tooLong && !loading;

  return (
    <Box>
      <TextField
        fullWidth
        multiline
        rows={8}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder="Paste the campaign brief. Objective, audience, platforms, budget, timelines — whatever you have."
        error={tooLong}
        disabled={loading}
      />

      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mt: 0.75 }}>
        <Typography variant="caption" color={tooLong ? 'error' : 'text.secondary'}>
          {value.length.toLocaleString()} / {MAX_BRIEF_CHARS.toLocaleString()} characters
        </Typography>
      </Stack>

      {value.trim().length === 0 && (
        <Box sx={{ mt: 1.5 }}>
          <Typography variant="caption" color="text.secondary">
            Or start from an example:
          </Typography>
          <Stack direction="row" flexWrap="wrap" gap={0.75} sx={{ mt: 0.75 }}>
            {SAMPLES.map((sample) => (
              <Chip
                key={sample}
                label={sample}
                size="small"
                variant="outlined"
                onClick={() => onChange(sample)}
              />
            ))}
          </Stack>
        </Box>
      )}

      <Button
        variant="contained"
        onClick={onAnalyse}
        disabled={!canAnalyse}
        startIcon={loading ? <CircularProgress size={16} color="inherit" /> : <AutoAwesomeIcon />}
        sx={{ mt: 2 }}
      >
        {loading ? 'Reading the brief…' : 'Analyse brief'}
      </Button>
    </Box>
  );
}

export default BriefInput;
